module.exports = __webpack_public_path__ + "static/media/fleshBas.0db5cf60.svg";